export default class ProcessingActivityModelReadModel {
  static getAll() {}
}
